<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <v-row>
        <v-col>
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">
                Library List
              </h3>
              <router-link
                :to="{ path: 'library/create' }"
                class="float-right mt-0"
              >
                <v-tooltip
                  bottom
                  :color="$vuetify.theme.themes.light.tooltipColor"
                >
                  <template v-slot:activator="{ on: tooltip, attrs }">
                    <img
                      class="mr-2"
                      v-bind="attrs"
                      v-on="{ ...tooltip }"
                      src="@/assets/images/Plus.svg"
                    />
                  </template>
                  <span>Add Library</span>
                </v-tooltip>
              </router-link>
            </div>
            <v-card>
              <v-card-title>
                <v-row>
                  <v-col>
                    <v-text-field
                      class="search-text-field"
                      v-model="search"
                      append-icon="search"
                      label="Search by Name"
                      single-line
                      hide-details
                      v-debounce:1s="searchFilter"
                      :debounce-events="['click', 'keydown']"
                    ></v-text-field>
                  </v-col>
                  
                  <v-col>
                    <v-select
                      :items="statusArr"
                      item-value="value"
                      item-text="name"
                      label="Select Status"
                      v-model="status"
                      @change="statusFilter"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="library"
                :loading="loading"
                loading-text="Loading... Please wait"
                :page.sync="page"
                :items-per-page="itemsPerPage"
                hide-default-footer
              >
                <template v-slot:[`item.title`]="{ item }">
                  <div>{{ item.title }}</div>
                </template>

                <template v-slot:[`item.isActive`]="{ item }">
                  <v-chip
                    label
                    :color="getColor(item)"
                    dark
                    v-if="!item.isDelete"
                  >{{ item.isActive? 'Active' : 'Inactive' }}</v-chip>
                  <v-chip
                    label
                    class="mx-2"
                    v-if="item.isDelete"
                    :color="getColor(item)"
                    dark
                  >{{ item.isDelete? 'Deleted' : 'no' }}</v-chip>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <router-link :to="{ path: 'library/' + item._id }">
                    <v-tooltip
                      bottom
                      :color="$vuetify.theme.themes.light.tooltipColor"
                    >
                      <template v-slot:activator="{ on: tooltip, attrs }">
                        <img
                          v-bind="attrs"
                          v-on="{ ...tooltip }"
                          class="mr-2 edit-icon"
                          src="@/assets/images/Edit.svg"
                        />
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                  </router-link>

                  <delete-component
                    :id="item._id"
                    module="library/delete"
                    @requestDeleted="requestDeleted"
                  ></delete-component>
                </template>
              </v-data-table>

              <v-card-actions class="justify-end pt-2">
                <v-pagination
                  circle
                  v-model="page"
                  :length="pageCount"
                ></v-pagination>
              </v-card-actions>
            </v-card>
          </card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import CommonSection from "@/components/CommonHeader";
import DeleteComponent from "@/components/DeleteComponent";
import { LibraryService } from "@/services";

export default {
  name: "library",
  components: {
    CommonSection,
    DeleteComponent,
  },
  data: () => ({
    page: 1,
    pageCount: 0,
    loading: true,
    itemsPerPage: 50,
    library: [],
    search: null,
    status: true,
    statusArr: [
      {
        name: "All",
        value: "",
      },
      {
        name: "Active",
        value: true,
      },
      {
        name: "Inactive",
        value: false,
      },
    ],
    headers: [
      {
        text: "Name",
        align: "start",
        value: "name",
      },
      { text: "Publisher", value: "publisher" },
      { text: "Status", value: "isActive" },
      { text: "Actions", value: "actions", sortable: false },
    ],
  }),
  watch: {
    page() {
      this.initialize();
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.loading = true;
      const params = {
        limit: parseInt(this.itemsPerPage),
        skip:
          parseInt(this.page) * parseInt(this.itemsPerPage) -
          parseInt(this.itemsPerPage),
        name: this.search,
      };
      params.isActive = this.status;
      const libraries = await LibraryService.libraryList(params);
      if (libraries.data.data.length > 0) {
        this.pageCount = Math.ceil(
          libraries.data.option[0].count / this.itemsPerPage
        );
        this.library = libraries.data.data;
        this.loading = false;
      } else {
        if (this.page !== 1) {
          this.page--;
        }
        this.loading = false;
        this.library = [];
      }
    },
    searchFilter() {
      this.page = 1;
      this.initialize();
    },
    statusFilter() {
      this.page = 1;
      this.initialize();
    },
    requestDeleted() {
      this.initialize();
    },
    getColor(object) {
      if (object.isActive) {
        return "#30E362";
      } else if (object.isDelete) {
        return "red";
      } else {
        return "#5B5B5B";
      }
    },
  },
};
</script>
